import React from 'react';
import AdminV2TournamentDetail from '../../admin-v2/tournaments/Detail';

/** Manager V2 Tournament Detail — read-only. Feature : pages.tournaments.manager. */
const ManagerV2TournamentDetail = () => (
  <AdminV2TournamentDetail backPath="/manager/tournaments" />
);

export default ManagerV2TournamentDetail;
